import styles from './Toggle.css'
import moment from 'moment'
import {Button} from 'react-bootstrap'

class Toggle extends React.Component {
  render () {
    let isSameDate = moment(this.props.startDate).isSame(moment(this.props.endDate), 'days')
    return (<Button
      bsClass={`btn btn-default ${!this.props.fullSiteMode ? styles['wrapper'] : isSameDate ? styles['same-date'] : styles['range-date']}`}
      onClick={this.props.onClick}>
      {this._label()} <i className='fa fa-angle-down' />
    </Button>)
  }

  _label = () => {
    let {startDate, endDate} = this.props
    if (!startDate || !endDate) {
      return 'Loading...'
    } else {
      return moment(startDate).isSame(moment(endDate), 'days')
        ? moment(startDate).format('D/MM/YYYY')
        : `${moment(startDate).format('D/MM/YYYY')} - ${moment(endDate).format('D/MM/YYYY')}`
    }
  }
}

Toggle.propTypes = {
  startDate: React.PropTypes.object,
  endDate: React.PropTypes.object,
  onClick: React.PropTypes.func
}

export default Toggle



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownCalendarPromo/Toggle/Toggle.js